module.exports = __webpack_public_path__ + "img/pencil-icon.236a5cec.svg";